import { Grid, Typography } from '@mui/material';
import * as React from 'react';

import { muiStyles } from './styles';
import { TransactionDetailProps } from './types';

export default function TransactionDetail(props: TransactionDetailProps) {
    const {
        id,
        children,
        orientation = 'row',
        label,
        attribute,
        tight = false
    } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            className={tight ? classes.tightContainer : classes.container}
            container
            direction={orientation}
            spacing={0}
            wrap='nowrap'
        >
            {orientation === 'row' ? (
                <>
                    <Grid
                        item
                        xs={4}
                    >
                        <Typography
                            className={classes.label}
                            id={id ? `${id}_label` : ''}
                            variant='body2'
                        >
                            {label}
                        </Typography>
                    </Grid>
                    {attribute && (
                        <Grid
                            item
                            xs={8}
                        >
                            <Typography
                                className={classes.attribute}
                                id={id ? `${id}_value` : ''}
                                variant='body1'
                            >
                                {attribute}
                            </Typography>
                        </Grid>
                    )}
                    {children && (
                        <Grid
                            item
                            xs={8}
                        >
                            {children}
                        </Grid>
                    )}
                </>
            )
                : (
                    <>
                        <Typography
                            className={classes.label}
                            id={id ? `${id}_label` : ''}
                            variant='body2'
                        >
                            {label}
                        </Typography>
                        {attribute && (
                            <Typography
                                className={classes.attribute}
                                id={id ? `${id}_value` : ''}
                                variant='body1'
                            >
                                {attribute}
                            </Typography>
                        )}
                        {children}
                    </>
                )}
        </Grid>
    );
}